import {
  TTranslationAppearanceForm,
  TTranslationAppearanceTheme,
} from '@/page/general-settings/appearance/appearance.ts';

const appearanceForm: TTranslationAppearanceForm = {
  colorTheme: {
    label: 'Color theme',
    tooltip: 'Sets the colors of Qmulus. Each preview shows the theme in the selected density.',
  },
  density: {
    label: 'Density',
    tooltip: 'Sets how much space Qmulus leaves between elements. Compact shows more content at once, wide gives elements more room.',
  },
  locale: {
    label: 'Language',
    tooltip: 'Allows you to select the desired language and locale for the user interface.',
  },
  fontSize: {
    label: 'Page scaling',
    tooltip: 'Allows you to adjust the size of the font and ui element.',
  },
  chartTimeFormat: {
    label: 'Chart time format',
    tooltip: 'Specifies how dates and timestamps are displayed on the X-axis of charts.',
  },
  unitSystem: {
    label: 'Unit system',
    tooltip: 'Choose your preferred measurement units (e.g., metric or imperial) for displaying values.',
  },
  scaleOption: {
    label: 'Layout scaling',
    tooltip: 'Specifies how the scaling of the shop layout should be displayed.',
  },
  showOnlyAvailableApps: {
    label: 'Show only available apps?',
    tooltip: 'Hides apps that are not available to the user.',
  },
  hasOptedOutOfReleaseHighlights: {
    label: 'Show release highlights after updates?',
    tooltip: 'Shows the highlights of new Qmulus versions once after an update. They are always available on the page that opens when clicking the version number in the user menu.',
  },
};

const appearanceTheme: TTranslationAppearanceTheme = {
  colorThemeOption: {
    'qmulus-light': 'Qmulus Light',
    'qmulus-g10': 'Qmulus Gray 10',
    'qmulus-g90': 'Qmulus Gray 90',
    'qmulus-dark': 'Qmulus Dark',
    'aichelin-light': 'Aichelin Light',
    'aichelin-dark': 'Aichelin Dark',
    'pt9000-modern': 'PT9000 Modern',
    'pt9000': 'PT9000',
    'galaxy-desert': 'Galaxy Desert',
    'galaxy-snow': 'Galaxy Snow',
    'galaxy-void': 'Galaxy Void',
    'galaxy-ember': 'Galaxy Ember',
  },
  densityOption: {
    compact: 'Compact',
    regular: 'Regular',
    wide: 'Wide',
  },
};

export default {
  subline: 'Change the way Qmulus looks and feels',
  appearanceForm,
  appearanceTheme,
};
